// 韩漫YY榜 - 站内数据
// 说明：所有书名、作者均为站内虚构推荐内容，仅用于展示分类与榜单结构。

export interface Comic {
  id: string;
  title: string;
  author: string;
  category: string;
  categoryId: string;
  status: string; // 连载中 / 已完结
  score: number;
  chapters: number;
  views: string;
  tags: string[];
  intro: string;
  cover: string;
  featured?: boolean;
}

export interface Category {
  id: string;
  name: string;
  en: string;
  desc: string;
  count: string;
  color: string;
  image: string;
}

export const categories: Category[] = [
  {
    id: "romance",
    name: "恋爱",
    en: "Romance",
    desc: "怦然心动的邂逅、甜虐交织的感情线，一次看个够。",
    count: "1.2万+ 部",
    color: "primary",
    image:
      "https://readdy.ai/api/search-image?query=Romantic%20Korean%20webtoon%20cover%20art%20of%20a%20young%20couple%20standing%20under%20cherry%20blossom%20trees%20at%20golden%20hour%2C%20soft%20pastel%20pink%20and%20warm%20coral%20palette%2C%20stylized%20illustration%2C%20clean%20linework%2C%20dreamy%20atmosphere%2C%20editorial%20comic%20poster%2C%20high%20detail&width=600&height=750&seq=cat-romance-01&orientation=portrait",
  },
  {
    id: "fantasy",
    name: "奇幻",
    en: "Fantasy",
    desc: "异世界冒险、魔法契约与架空大陆，想象力永不设限。",
    count: "9.6k 部",
    color: "accent",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20fantasy%20Korean%20webtoon%20cover%20illustration%20of%20a%20young%20mage%20holding%20a%20glowing%20orb%20in%20a%20floating%20city%2C%20warm%20amber%20and%20deep%20teal%20palette%2C%20stylized%20anime%20art%2C%20dramatic%20lighting%2C%20magical%20particles%2C%20detailed%20comic%20poster&width=600&height=750&seq=cat-fantasy-01&orientation=portrait",
  },
  {
    id: "school",
    name: "校园",
    en: "School",
    desc: "教室里的小心思、天台上的约定，青春正当时。",
    count: "8.1k 部",
    color: "secondary",
    image:
      "https://readdy.ai/api/search-image?query=Youthful%20Korean%20webtoon%20cover%20of%20school%20students%20walking%20through%20a%20sunlit%20campus%20corridor%20with%20backpacks%2C%20fresh%20mint%20and%20warm%20cream%20palette%2C%20stylized%20illustration%2C%20bright%20natural%20light%2C%20energetic%20composition%2C%20high%20detail%20comic%20poster&width=600&height=750&seq=cat-school-01&orientation=portrait",
  },
  {
    id: "mystery",
    name: "悬疑",
    en: "Mystery",
    desc: "层层反转的谜团，看似平静的日常下暗流涌动。",
    count: "7.4k 部",
    color: "foreground",
    image:
      "https://readdy.ai/api/search-image?query=Moody%20Korean%20webtoon%20cover%20of%20a%20detective%20silhouette%20under%20a%20flickering%20streetlamp%20in%20a%20rainy%20alley%2C%20charcoal%20and%20warm%20amber%20palette%2C%20stylized%20illustration%2C%20mysterious%20noir%20atmosphere%2C%20dramatic%20contrast%2C%20high%20detail&width=600&height=750&seq=cat-mystery-01&orientation=portrait",
  },
  {
    id: "urban",
    name: "都市",
    en: "Urban",
    desc: "霓虹与旧街巷交织的城市，藏着无数相遇与告别。",
    count: "9.0k 部",
    color: "primary",
    image:
      "https://readdy.ai/api/search-image?query=Urban%20Korean%20webtoon%20cover%20of%20a%20city%20rooftop%20at%20dusk%20overlooking%20glowing%20skyscrapers%2C%20warm%20coral%20and%20teal%20twilight%20palette%2C%20stylized%20illustration%2C%20nostalgic%20mood%2C%20detailed%20skyline%2C%20high%20detail%20comic%20poster&width=600&height=750&seq=cat-urban-01&orientation=portrait",
  },
  {
    id: "office",
    name: "职场",
    en: "Office",
    desc: "格子间里的博弈与心动，成年人的二次元战场。",
    count: "5.8k 部",
    color: "accent",
    image:
      "https://readdy.ai/api/search-image?query=Stylish%20Korean%20webtoon%20cover%20of%20young%20professionals%20in%20a%20modern%20glass%20office%20at%20sunset%2C%20warm%20amber%20and%20cream%20palette%2C%20stylized%20illustration%2C%20sleek%20corporate%20mood%2C%20clean%20composition%2C%20high%20detail&width=600&height=750&seq=cat-office-01&orientation=portrait",
  },
  {
    id: "action",
    name: "热血",
    en: "Action",
    desc: "少年意气与燃向战斗，逆袭之路永不停歇。",
    count: "6.6k 部",
    color: "secondary",
    image:
      "https://readdy.ai/api/search-image?query=Energetic%20Korean%20webtoon%20cover%20of%20a%20determined%20young%20fighter%20with%20dynamic%20motion%20lines%20and%20sparks%2C%20vivid%20teal%20and%20coral%20palette%2C%20stylized%20illustration%2C%20powerful%20pose%2C%20explosive%20energy%2C%20high%20detail%20comic%20poster&width=600&height=750&seq=cat-action-01&orientation=portrait",
  },
  {
    id: "healing",
    name: "治愈",
    en: "Healing",
    desc: "平凡日常里的温柔，让紧绷的心慢慢松弛下来。",
    count: "6.1k 部",
    color: "primary",
    image:
      "https://readdy.ai/api/search-image?query=Soothing%20Korean%20webtoon%20cover%20of%20a%20cozy%20cafe%20with%20steaming%20coffee%20and%20a%20calm%20cat%20by%20the%20window%2C%20warm%20cream%20and%20soft%20coral%20palette%2C%20stylized%20illustration%2C%20gentle%20lighting%2C%20peaceful%20atmosphere%2C%20high%20detail&width=600&height=750&seq=cat-healing-01&orientation=portrait",
  },
];

export const comics: Comic[] = [
  {
    id: "seoul-contract",
    title: "首尔契约",
    author: "昼灯",
    category: "恋爱 / 奇幻",
    categoryId: "romance",
    status: "已完结",
    score: 9.6,
    chapters: 188,
    views: "486万",
    tags: ["契约恋爱", "神明", "甜虐"],
    intro:
      "濒临破产的家族继承人白汐，在首尔旧宅的阁楼上遇到了一位来历不明的神秘男人。他以一份「契约」交换她的自由，而契约的代价，远不止一句承诺那么简单。当真相一层层揭开，她才发现，自己卷入了跨越百年的神明赌局。",
    cover:
      "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20of%20a%20mysterious%20handsome%20man%20in%20a%20long%20dark%20coat%20standing%20in%20front%20of%20an%20old%20Seoul%20mansion%2C%20warm%20coral%20and%20deep%20charcoal%20palette%2C%20stylized%20illustration%2C%20dramatic%20lighting%2C%20romantic%20fantasy%20atmosphere%2C%20detailed%20character%20art%2C%20high%20quality%20comic%20poster&width=600&height=800&seq=cover-seoul-01&orientation=portrait",
    featured: true,
  },
  {
    id: "morning-convenience",
    title: "清晨便利店",
    author: "栗子汽水",
    category: "治愈 / 日常",
    categoryId: "healing",
    status: "连载中",
    score: 9.4,
    chapters: 96,
    views: "302万",
    tags: ["治愈", "邻里", "慢生活"],
    intro:
      "凌晨四点的便利店，是这座城市的秘密集会所。值夜班的女孩小满，每天都会遇到形形色色的夜归人——加班的上班族、失眠的学生、带着猫粮的老人。她用一杯热饮和一段倾听，慢慢治愈着每一个疲惫的灵魂，也在其中重新找到了自己生活的方向。",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20Korean%20webtoon%20cover%20of%20a%20convenience%20store%20at%20night%20with%20warm%20glowing%20lights%20and%20a%20gentle%20female%20clerk%20holding%20a%20steaming%20cup%2C%20warm%20cream%20and%20soft%20coral%20palette%2C%20stylized%20illustration%2C%20peaceful%20nocturnal%20atmosphere%2C%20high%20detail%20comic%20poster&width=600&height=800&seq=cover-convenience-01&orientation=portrait",
    featured: true,
  },
  {
    id: "rose-alley-cat",
    title: "蔷薇街的猫",
    author: "林间风",
    category: "都市 / 恋爱",
    categoryId: "urban",
    status: "已完结",
    score: 9.2,
    chapters: 142,
    views: "261万",
    tags: ["都市", "猫系男主", "治愈系"],
    intro:
      "蔷薇街有一家只在雨天营业的花店，店主是个说话很少、却总能在你最难的时候出现的人。一次偶然，误入花店的插画师苏禾，与店主之间展开了一段关于遗憾、告别与重逢的都市故事。街角的猫，是这段缘分最安静的见证者。",
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20Korean%20webtoon%20cover%20of%20a%20quiet%20flower%20shop%20in%20the%20rain%20with%20a%20young%20man%20and%20a%20cat%20by%20the%20door%2C%20warm%20coral%20and%20soft%20teal%20palette%2C%20stylized%20illustration%2C%20rainy%20melancholic%20mood%2C%20high%20detail%20comic%20poster&width=600&height=800&seq=cover-rosecat-01&orientation=portrait",
  },
  {
    id: "parachute-confession",
    title: "降落伞告白",
    author: "一颗青柠",
    category: "校园 / 恋爱",
    categoryId: "school",
    status: "连载中",
    score: 9.5,
    chapters: 74,
    views: "198万",
    tags: ["青春", "青梅竹马", "轻喜"],
    intro:
      "高二那年，转学生陆迟把一封情书错塞进了同桌的伞里。从那天起，他成了全校都知道的「降落伞告白事件」主角。一场乌龙开启的暗恋，在教室、操场与天台之间慢慢发酵。青春的喜欢，就像一把没撑开的伞，等你鼓起勇气打开的那天。",
    cover:
      "https://readdy.ai/api/search-image?query=Youthful%20Korean%20webtoon%20cover%20of%20a%20high%20school%20boy%20holding%20an%20open%20umbrella%20under%20a%20clear%20blue%20sky%20with%20cherry%20blossoms%2C%20fresh%20mint%20and%20warm%20cream%20palette%2C%20stylized%20illustration%2C%20bright%20playful%20mood%2C%20high%20detail%20comic%20poster&width=600&height=800&seq=cover-parachute-01&orientation=portrait",
    featured: true,
  },
  {
    id: "mist-detective",
    title: "迷雾侦探社",
    author: "白桦",
    category: "悬疑 / 都市",
    categoryId: "mystery",
    status: "连载中",
    score: 9.7,
    chapters: 110,
    views: "533万",
    tags: ["推理", "单元剧", "高能反转"],
    intro:
      "一间只在深夜营业的侦探社，接受任何看似不可能的委托。年轻的侦探韩序拥有惊人的观察力，却对十年前那场大火毫无记忆。当委托案件的线索一次次指向当年的真相，他不得不面对一个残酷的事实——也许他本人，就是故事里最关键的拼图。",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20Korean%20webtoon%20cover%20of%20a%20young%20detective%20in%20a%20trench%20coat%20holding%20a%20magnifying%20glass%20in%20a%20dim%20nocturnal%20office%2C%20charcoal%20and%20warm%20amber%20palette%2C%20stylized%20illustration%2C%20mysterious%20noir%20atmosphere%2C%20high%20detail%20comic%20poster&width=600&height=800&seq=cover-mist-01&orientation=portrait",
    featured: true,
  },
  {
    id: "penthouse-demon",
    title: "顶楼有妖",
    author: "夜半小灯",
    category: "奇幻 / 都市",
    categoryId: "fantasy",
    status: "已完结",
    score: 9.1,
    chapters: 130,
    views: "177万",
    tags: ["妖怪", "都市奇谭", "轻喜剧"],
    intro:
      "老旧公寓的顶楼，住着一位看不出年龄的房东，和一屋子以「租客」身份混迹人间的妖怪。新来的租客记者老周，本想调查一桩灵异事件，却意外成了这栋楼的「知情人」。人与妖在同一屋檐下斗嘴、互助，也慢慢拼凑出这座城市的另一面。",
    cover:
      "https://readdy.ai/api/search-image?query=Playful%20Korean%20webtoon%20cover%20of%20a%20quirky%20old%20apartment%20rooftop%20at%20night%20with%20glowing%20lanterns%20and%20mysterious%20creatures%2C%20warm%20amber%20and%20teal%20palette%2C%20stylized%20illustration%2C%20whimsical%20urban%20fantasy%20mood%2C%20high%20detail%20comic%20poster&width=600&height=800&seq=cover-penthouse-01&orientation=portrait",
  },
  {
    id: "desk-lovers",
    title: "工位上的恋人",
    author: "焦糖拿铁",
    category: "职场 / 恋爱",
    categoryId: "office",
    status: "连载中",
    score: 9.3,
    chapters: 88,
    views: "243万",
    tags: ["办公室", "冤家", "成年人恋爱"],
    intro:
      "同一家公司、一墙之隔，冷静的项目经理韩澈和总是踩线交方案的设计师夏朵，是全公司公认的「天敌」。可一次次深夜加班、一次次并肩作战后，那堵看不见的墙，开始悄悄松动。成年人的喜欢，往往藏在一句「辛苦了」里。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylish%20Korean%20webtoon%20cover%20of%20two%20young%20colleagues%20working%20late%20in%20a%20modern%20office%20with%20soft%20warm%20lamp%20light%2C%20warm%20amber%20and%20cream%20palette%2C%20stylized%20illustration%2C%20romantic%20corporate%20mood%2C%20high%20detail%20comic%20poster&width=600&height=800&seq=cover-desk-01&orientation=portrait",
  },
  {
    id: "first-transfer-day",
    title: "转学第一天",
    author: "夏至未至",
    category: "校园 / 恋爱",
    categoryId: "school",
    status: "已完结",
    score: 8.9,
    chapters: 102,
    views: "156万",
    tags: ["转学生", "社团", "青春群像"],
    intro:
      "因为父亲的工作调动，时语在高一下学期转学来到这座陌生的城市。她以为会迎来一段安静平淡的日子，却在入学第一天，就被排球社的「热血笨蛋」部长当成了久别的故人。一场乌龙，让她的新生活从鸡飞狗跳开始。",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20Korean%20webtoon%20cover%20of%20a%20new%20student%20with%20a%20backpack%20walking%20into%20a%20sunny%20school%20courtyard%20with%20friends%2C%20fresh%20mint%20and%20warm%20coral%20palette%2C%20stylized%20illustration%2C%20optimistic%20youthful%20mood%2C%20high%20detail%20comic%20poster&width=600&height=800&seq=cover-transfer-01&orientation=portrait",
  },
  {
    id: "riverside-bistro",
    title: "江边小馆",
    author: "陈皮",
    category: "治愈 / 美食",
    categoryId: "healing",
    status: "连载中",
    score: 9.2,
    chapters: 67,
    views: "121万",
    tags: ["美食", "治愈", "人生百味"],
    intro:
      "江边有一家只做夜宵的小馆子，老板不善言辞，却记得每一位常客的口味。一锅热汤、一盘下饭菜，就能换一个故事。每一道菜背后，都是一个普通人的悲喜人生。这家小馆，用最简单的味道，抚慰着城市里最疲惫的心。",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20Korean%20webtoon%20cover%20of%20a%20small%20riverside%20restaurant%20at%20night%20with%20steaming%20food%20and%20warm%20lantern%20light%2C%20warm%20cream%20and%20soft%20coral%20palette%2C%20stylized%20illustration%2C%20comforting%20homely%20mood%2C%20high%20detail%20comic%20poster&width=600&height=800&seq=cover-bistro-01&orientation=portrait",
  },
  {
    id: "all-villains",
    title: "全员反派",
    author: "临界点",
    category: "热血 / 奇幻",
    categoryId: "action",
    status: "连载中",
    score: 9.4,
    chapters: 121,
    views: "342万",
    tags: ["逆袭", "战斗", "群像"],
    intro:
      "这个世界的规则很简单：要么当主角，要么当炮灰。可偏偏有一群被判定为「反派」的家伙，拒绝认命。他们凑在一起，用最不靠谱的方式，把每一次必死的绝境，都硬生生打成了翻盘名场面。全员反派，全员热血。",
    cover:
      "https://readdy.ai/api/search-image?query=Energetic%20Korean%20webtoon%20cover%20of%20a%20group%20of%20defiant%20young%20fighters%20standing%20back%20to%20back%20with%20dynamic%20action%20lines%2C%20vivid%20coral%20and%20teal%20palette%2C%20stylized%20illustration%2C%20powerful%20rebellious%20mood%2C%20high%20detail%20comic%20poster&width=600&height=800&seq=cover-villains-01&orientation=portrait",
    featured: true,
  },
  {
    id: "frozen-time",
    title: "时间停滞之时",
    author: "长歌",
    category: "悬疑 / 奇幻",
    categoryId: "mystery",
    status: "已完结",
    score: 9.0,
    chapters: 98,
    views: "168万",
    tags: ["时间循环", "烧脑", "悬疑"],
    intro:
      "下午四点十七分，这座城市的时间忽然停止。唯一还在移动的，是普通上班族林默。他必须在每天重启的六小时里，找出时间停滞的真正原因。可每一次循环，都让他发现，自己离真相越近，就越接近一个不敢面对的答案。",
    cover:
      "https://readdy.ai/api/search-image?query=Surreal%20Korean%20webtoon%20cover%20of%20a%20frozen%20city%20at%20a%20standstill%20with%20one%20walking%20figure%2C%20charcoal%20and%20warm%20amber%20palette%2C%20stylized%20illustration%2C%20eerie%20time%20loop%20atmosphere%2C%20high%20detail%20comic%20poster&width=600&height=800&seq=cover-frozen-01&orientation=portrait",
  },
  {
    id: "convenience-night",
    title: "便利店夜班",
    author: "暗巷",
    category: "都市 / 悬疑",
    categoryId: "urban",
    status: "连载中",
    score: 8.8,
    chapters: 55,
    views: "92万",
    tags: ["悬疑", "夜班", "都市传说"],
    intro:
      "为了赚取学费，大学生阿哲接下了便利店夜班的工作。他很快发现，凌晨两点之后，这家店总会来一些「不太对劲」的客人。他们每个人都带着一个秘密而来，而这家便利店的老板，似乎知道所有答案。",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20atmospheric%20Korean%20webtoon%20cover%20of%20a%20solitary%20convenience%20store%20at%20midnight%20in%20the%20rain%20with%20a%20mysterious%20figure%20inside%2C%20charcoal%20and%20warm%20coral%20palette%2C%20stylized%20illustration%2C%20suspenseful%20nocturnal%20mood%2C%20high%20detail&width=600&height=800&seq=cover-convnight-01&orientation=portrait",
  },
  {
    id: "heartbeat-signal",
    title: "心动信号灯",
    author: "软糖",
    category: "恋爱 / 都市",
    categoryId: "romance",
    status: "连载中",
    score: 9.1,
    chapters: 79,
    views: "214万",
    tags: ["双向暗恋", "都市", "甜宠"],
    intro:
      "绿灯亮起的那一刻，是他一天里唯一敢看向她的瞬间。斑马线两端的两个陌生人，因为每天同一时间的相遇，悄悄把心事写进了红绿灯的每一次更替里。直到某一天，信号灯下的重逢，让这场无声的心动终于有了回音。",
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20Korean%20webtoon%20cover%20of%20a%20young%20man%20and%20woman%20on%20opposite%20sides%20of%20a%20crosswalk%20at%20night%20with%20glowing%20traffic%20lights%2C%20warm%20coral%20and%20teal%20palette%2C%20stylized%20illustration%2C%20sweet%20moody%20atmosphere%2C%20high%20detail%20comic%20poster&width=600&height=800&seq=cover-signal-01&orientation=portrait",
  },
  {
    id: "boy-agency",
    title: "少年事务所",
    author: "火柴",
    category: "热血 / 校园",
    categoryId: "action",
    status: "已完结",
    score: 9.3,
    chapters: 156,
    views: "389万",
    tags: ["竞技", "团队", "热血成长"],
    intro:
      "一支濒临解散的高中电竞社，一群性格迥异的「问题少年」，和一位一心想拿回奖杯的退役教练。他们从全校垫底，一路杀进全国决赛。热血、友情与胜负之间，少年们用一场场比赛，写下了属于自己的答案。",
    cover:
      "https://readdy.ai/api/search-image?query=Exciting%20Korean%20webtoon%20cover%20of%20a%20team%20of%20high%20school%20esports%20players%20with%20headsets%20in%20front%20of%20glowing%20screens%2C%20vivid%20coral%20and%20teal%20palette%2C%20stylized%20illustration%2C%20energetic%20competitive%20mood%2C%20high%20detail%20comic%20poster&width=600&height=800&seq=cover-agency-01&orientation=portrait",
    featured: true,
  },
];

export const hotRanking: string[] = [
  "mist-detective",
  "seoul-contract",
  "all-villains",
  "morning-convenience",
  "parachute-confession",
  "boy-agency",
  "heartbeat-signal",
  "desk-lovers",
  "rose-alley-cat",
  "frozen-time",
];

export const faqs = [
  {
    q: "韩漫YY榜的人气榜单多久更新一次？",
    a: "我们的人气榜单每天凌晨自动更新，综合阅读热度、收藏量和近7日新增互动综合计算，力求实时反映当前最受读者欢迎的韩漫作品。你也可以在首页通过「周榜」「月榜」切换查看不同时间维度的排名。",
  },
  {
    q: "什么是「完结漫画」分类？",
    a: "「完结漫画」是指故事已经全部更新完毕的作品。这类漫画适合一口气追完、不喜欢追更的读者。我们为每部完结作品整理了完整的章节数、结局信息，方便你一次性看到最后。",
  },
  {
    q: "新番抢先看板块里的作品有什么特别之处？",
    a: "新番板块收录了近期刚上架、正在火热连载的新作品。我们会标注作品的题材标签、评分走势和首发热度，帮助你在作品还冷门时就能抢先发现潜力佳作，提前「上车」。",
  },
  {
    q: "评分是怎么来的？",
    a: "每部作品的评分由站内读者打分与作品数据综合得出，采用 10 分制。评分会随读者的持续打分动态变化，榜单上排名靠前的作品，通常都是口碑与热度兼备的佳作。",
  },
  {
    q: "我可以在分类里快速找到喜欢的题材吗？",
    a: "可以。我们按恋爱、奇幻、校园、悬疑、都市、职场、热血、治愈等常见题材划分了分类页，你可以按分类浏览，也可以使用筛选器按照「连载中 / 已完结」状态进一步筛选，快速定位心仪的作品。",
  },
  {
    q: "书荒的时候该怎么挑书？",
    a: "书荒时建议优先参考我们的高评分榜单和「本周热门」板块，这些作品经过大量读者验证，踩雷概率更低。你也可以关注自己感兴趣分类下的新番，说不定能发现惊喜。",
  },
];

export const siteMeta = {
  name: "韩漫YY榜",
  slogan: "一榜看懂好韩漫",
  desc: "韩国漫画yy排行榜精选，韩漫人气榜单与完结漫画分类实时更新，新番抢先看，追榜选书更高效。",
  email: "hello@hanmanyy.example",
};